export default {
  type: "establishment-internal-invoice-items",
  storable: {
    type: "products",
    id: null,
  },
  unitOfMeasureUnit: {
    type: "unit-of-measure-units",
    id: null,
  },
  relationshipNames: [
    "unitOfMeasureUnit",
    "storable",
    "internalInvoice",
  ],
  quantity: 1,
};
